import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import './style.css';

class Aboutpage extends Component {
  constructor(props) {
    super(props)
    // We put on state the properties we want to use and modify in the component
    this.state = {

    }
  }

  componentDidMount() {
    this.props.model.addObserver(this);
  }

  componentWillUnmount() {
    this.props.model.removeObserver(this);
  }

  update() {
    // setState causes the component to re-render
    this.setState({

    });
  }


  render() {
    return(
      <div className="detail-title">
        <div className="detail-title row">
          About I Wayan Kurniawan
        </div>
        
        <div className="row">
          <div className="col-sm-2">
          </div>
          <button id="github" className="col-sm-4 btn"><a href="https://github.com/iwayankurniawan" target="_blank">Github</a></button>
          <button id="Linkedin" className=" col-sm-4 btn"><a href="https://www.linkedin.com/in/i-wayan-kurniawan-aditya-wardana-1b4966114/" target="_blank">Linkedin</a></button>
          <div className="col-sm-2">
          </div>
        </div>
        <div className="detail-description-about row">
          <div className="col-sm-2">
          </div>
          <div className="col-sm-8">
            <p>Hi, I am Wayan. I Design & Build anything related with AR, Android, Website & Computer Graphics</p>
            <br></br>
            <p>I currently study as master student in KTH Royal Institute of Technology majoring Interactive Media Technology focusing in visualization track. I got scholarship from Swedish Institute to enrol in this major. In Interactive media technology major, I am taking several courses like visualization, computer graphics and interactions, advanced graphics and interactions, information visualization and introduction to visualization, computer graphics and image/video processing. Those courses help me to build capability in computer graphics theory for example in rendering, projections, shading.</p>
            <br></br>
            <p>During my free time, I love to traveling, taking some photos with my camera and blogging. Also as student I love to learn and research how to get extra money to increase my saving</p>
            <br></br>
            <p>Contact Me at: wardana@kth.se</p>
          </div>
          <div className="col-sm-2">
          </div>
        </div>
      </div>
    );
  }

}

export default Aboutpage;
